/**
 * ENVIRONMENT: PRODUCTION
 * MODULE: Root Application Component & Multi-Tab Session Guard
 * PATH: src/App.js
 */

import React, { useEffect } from 'react';

// styles
import 'antd/dist/antd.less';
import './assets/styles/index.scss';
import './assets/styles/mobile.scss';

// redux
import { Provider } from 'react-redux';
import store from 'redux/store';

// components
import { ConfigProvider } from 'antd';
import { BrowserRouter } from 'react-router-dom';
import AppRoutes from './routes';
import { ToastContainer } from 'react-toast';

// moment
import moment from 'moment-timezone';

moment.tz.setDefault('UTC');

const validateMessages = {
  required: 'Required',
};

const App = () => {
  // Cross-tab real-time session synchronization
  useEffect(() => {
    const handleStorageChange = (e) => {
      // If token key is modified across tabs
      if (e.key === 'token') {
        // If logged out in another tab, immediately bounce to login
        if (!e.newValue) {
          window.location.href = '/login';
        } else if (e.oldValue && e.newValue !== e.oldValue) {
          // If a new session token was issued, reload to refresh session state
          window.location.reload();
        }
      }
    };

    window.addEventListener('storage', handleStorageChange);
    return () => window.removeEventListener('storage', handleStorageChange);
  }, []);

  return (
    <Provider store={store}>
      <ConfigProvider form={{ validateMessages }}>
        <BrowserRouter>
          <AppRoutes />
        </BrowserRouter>

        <ToastContainer
          delay={3000}
          position="top-right"
        />
      </ConfigProvider>
    </Provider>
  );
};

export default App;